// extracted by mini-css-extract-plugin
export default {"Nav":"Nav_Nav__3ylzV","Nav__col":"Nav_Nav__col__2EZ6-","Nav__item":"Nav_Nav__item__2NZA8","Nav__link":"Nav_Nav__link__1VWgj"};